import LegalPage from "@/pages/legal/LegalPage";

export default function Refunds() {
  return (
    <LegalPage title="Cancellation & Refunds" testId="page-refunds">
      <p>
        We want LeadGen to feel like money well spent. If it doesn&apos;t, this page explains what we&apos;ll do.
      </p>

      <h2>1. Digital, one-time purchases</h2>
      <p>
        Our DIY Toolkit, Automated System and Pro plans are one-time digital purchases. The moment you buy, the
        corresponding plan is unlocked in your browser and you can download the PDF.
      </p>

      <h2>2. 7-day refund window</h2>
      <p>
        If you&apos;ve bought a one-time plan and feel it doesn&apos;t describe your business well enough to be
        useful, email <a href="mailto:support@madwithppc.com">support@madwithppc.com</a> within <strong>7 days</strong>
        of purchase with your order ID and a one-line reason. We&apos;ll either:
      </p>
      <ul>
        <li>regenerate the plan with your corrections at no extra cost, or</li>
        <li>refund 100% of what you paid.</li>
      </ul>

      <h2>3. When refunds are not available</h2>
      <ul>
        <li>Requests made more than 7 days after the purchase date.</li>
        <li>Requests where the plan has been downloaded as PDF, shared externally, or used to run live campaigns, and the business facts match the inputs you provided.</li>
        <li>Requests where the inputs you entered were deliberately misleading.</li>
      </ul>

      <h2>4. Setup &amp; monthly optimisation engagements</h2>
      <p>
        For services (Setup, Monthly Optimisation) priced on a bespoke basis, cancellation and refund terms are
        agreed in the signed engagement letter. In general: cancel any time before work starts for a full refund;
        after work starts, you pay for completed deliverables.
      </p>

      <h2>5. How refunds are processed</h2>
      <p>
        Refunds are issued to the original payment method via Razorpay and typically appear in your account
        within 5-10 business days, depending on your bank.
      </p>

      <h2>6. Chargebacks</h2>
      <p>
        If you believe a charge is wrong, please email us first — we&apos;ll usually resolve it faster than a
        chargeback. Repeated or fraudulent chargebacks may result in loss of access to the Service.
      </p>

      <h2>7. Account cancellation</h2>
      <p>
        LeadGen is session-based with no recurring subscription on the DIY / Automated / Pro tiers, so there is
        nothing to cancel. If you want your plans and uploads deleted, email{" "}
        <a href="mailto:support@madwithppc.com">support@madwithppc.com</a>.
      </p>

      <h2>8. Contact</h2>
      <p>
        Refund questions? Email <a href="mailto:support@madwithppc.com">support@madwithppc.com</a>.
      </p>
    </LegalPage>
  );
}
